import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, REFRESH_TIMESTAMP_KEY, USE_BEARER } from '../constants';
import qs from 'qs';
import { axiosRequest, axiosRequestEvents, updateTokens } from './utils';

const parseErrors = (err, errCb) => {
  const msg = err?.response?.data;

  if (msg) {
    errCb?.(msg);
  } else {
    errCb?.({ error: `${err?.name || 'Error'}' '${err?.message}`, type: 'ServerError' });
  }
};

export const getUserApi = async (dataCb, errCb) => {
  await axiosRequest
    .get('organizations/me', {
      _auth: true,
    })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const logInApi = async (user, dataCb, errCb) => {
  await axiosRequest
    .post('auth/sign-in', user)
    .then((res) => {
      dataCb(res);
      updateTokens(res.data?.access_token, res.data?.refresh_token);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const logout = async () => {
  await axiosRequest
    .post('auth/logout')
    .then(() => {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TIMESTAMP_KEY);
    })
    .catch((err) => {
      const msg = err?.response?.data;
      if (msg) {
        console.log(JSON.stringify(msg));
      } else {
        console.log('server missing or no internet');
      }
    });
};

export const signUpApi = async (user, dataCb, errCb) => {
  await axiosRequest
    .post('auth/signup', user)
    .then((res) => {
      dataCb(res);
      updateTokens(res.data?.access_token, res.data?.refresh_token);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

// быстрая регистрация:
export const quickSignUpApi = async (body, dataCb, errCb) => {
  try {
    const response = await axiosRequest.post('auth/admin/signup', body, { _auth: true });

    dataCb?.(response);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getRegisteredUsers = async (dataCb, errCb) => {
  try {
    const response = await axiosRequest.get('users/admin/created', { _auth: true });
    dataCb?.(response.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const verify = async (ticket, setRes, setProgress) => {
  const ticketJson = { ticket: ticket };
  await axiosRequest
    .post('auth/signup/verify', ticketJson)
    .then((res) => {
      setProgress(false);
      setRes(res.data);
    })
    .catch((err) => {
      setProgress(true);
      const msg = err?.response?.data;
      if (msg) {
        setRes(msg);
      } else {
        setRes({ error: err?.name + ' ' + err?.message, type: 'ServerError' });
      }
    });
};

export const verifyResetPassApi = async (ticket, dataCb, errCb) => {
  try {
    const response = await axiosRequest.post('auth/password/reset/verify', null, {
      params: { ticket },
    });
    dataCb(response.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const resetPassApi = async (ticket, pass, dataCb, errCb) => {
  const passJson = { password: pass };

  try {
    const response = await axiosRequest.post('auth/password/reset', passJson, {
      params: { ticket },
    });
    dataCb(response.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

//=====DEVICES API==============================================

export const getSummaryApi = async (dataCb, errCb) => {
  await axiosRequest
    .get('devices/summary', { _auth: true })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const getUsersApi = async (page = 1, count = 20, searchParams, dataCb, errCb) => {
  const newPage = page - 1; // на бэке отсчет page с 0

  const { name, email, phone, id } = searchParams ?? {};
  const params = {
    ...(id ? { id } : {}),
    ...(name ? { name } : {}),
    ...(email ? { email: email } : {}),
    ...(phone ? { phone } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get(`/users`, {
      _auth: true,
      params,
    });
    const { count: totalUsers, items } = response?.data ?? {};
    dataCb({ totalUsers, items });
  } catch (err) {
    const msg = err?.response?.data;
    if (msg) {
      errCb(msg);
    } else {
      console.error(err);
      errCb({ error: `${err?.name} ${err?.message}`, type: 'ServerError' });
    }
  }
};

export const getAddressesApi = async (page = 1, count = 20, address, dataCb, errCb) => {
  const newPage = page - 1;

  const params = {
    ...(address ? { address } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get(`devices/addresses`, {
      _auth: true,
      params,
    });
    dataCb(response?.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getControllersApi = async (page = 1, count = 20, serial_id, dataCb, errCb) => {
  const newPage = page - 1;

  const params = {
    ...(serial_id ? { serial_id } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get('/devices/controllers', { _auth: true, params });
    dataCb(response.data);
  } catch (err) {
    const msg = err?.response?.data;
    if (msg) {
      errCb(msg);
    } else {
      console.error(err);
      errCb({ error: `${err?.name} ${err?.message}`, type: 'ServerError' });
    }
  }
};

export const getAllDevicesApi = async ({ page = 1, count = 20, serial_id, object_id, type_key, dataCb, errCb } = {}) => {
  const newPage = page - 1;

  const params = {
    ...(serial_id ? { serial_id } : {}),
    ...(object_id ? { object_id } : {}),
    ...(type_key ? { type_key } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get('/devices/all', { _auth: true, params });
    dataCb?.(response.data);
    return response.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const resetPassRqApi = async (data, dataCb, errCb) => {
  await axiosRequest
    .post('auth/password/reset/link', data)
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const getCompanyEventsApi = async (page, limit, searchParams, dataCb, errCb) => {
  const offset = (page - 1) * limit;

  const { deviceId, userId, levels, categories, from, to, message } = searchParams ?? {};
  const params = {
    ...(categories?.length ? { categories } : {}),
    ...(message ? { message } : {}),
    ...(deviceId ? { deviceId: +deviceId } : {}),
    ...(userId ? { userId: +userId } : {}),
    ...(levels?.length ? { levels } : {}),
    ...(from ? { from: from } : {}),
    ...(to ? { to: to } : {}),
    offset,
    limit,
  };

  try {
    const res = await axiosRequestEvents.get(`/events/organization`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      _auth: true,
    });
    dataCb(res?.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getEventTypes = async (dataCb, errCb) => {
  try {
    const response = await axiosRequestEvents.get('/event_types');
    dataCb?.(response.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getListErrors = async (dataCb, errCb) => {
  try {
    const response = await axiosRequestEvents.get('/integrations/mosru/error_messages', { _auth: true });
    dataCb?.(response.data || []);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

//engineers:
export const getEngineers = async (page = 1, count = 20, sort_column, dataCb, errCb) => {
  const newPage = page - 1;

  const params = {
    ...(sort_column ? { sort_column } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get('users/admin/engineers', { _auth: true, params });
    dataCb?.(response.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const deleteEngineer = async (id, dataCb, errCb) => {
  try {
    await axiosRequest.delete(`auth/admin/engineers/${id}`, { _auth: true });
    dataCb?.();
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const sendEngineerInvitation = async (body, dataCb, errCb) => {
  try {
    await axiosRequest.post('auth/admin/engineers/invite', body, { _auth: true });
    dataCb?.();
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getInvitations = async (dataCb, errCb) => {
  try {
    const res = await axiosRequest.get('auth/admin/engineers/invite', { _auth: true });
    dataCb?.(res.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const signUpEngineer = async (user, dataCb, errCb) => {
  await axiosRequest
    .post('auth/engineers/signup', user)
    .then((res) => {
      dataCb(res);
      updateTokens(res?.data?.access_token, res?.data?.refresh_token);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

// справочники для поиска:
export const getUsersByQuery = async (params, dataCb, errCb) => {
  try {
    const response = await axiosRequest.get(`users/dict`, {
      params,
      _auth: true,
    });
    dataCb?.(response);
    return response;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getDevicesByQuery = async (params, dataCb, errCb) => {
  try {
    const response = await axiosRequest.get(`/devices/dict`, {
      params,
      _auth: true,
    });
    dataCb?.(response);
    return response;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getUserAccountTokens = async (userId, dataCb, errCb) => {
  try {
    const response = await axiosRequest.get(`auth/admin/srv/redirect/${userId}`, {
      _auth: true,
    });
    dataCb?.(response.data);
    return response;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const resendLinkVerification = async (body, dataCb, errCb) => {
  try {
    await axiosRequest.post('auth/resend-verification', body, {
      _auth: true,
    });
    dataCb?.();
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getNbIotDevices = async ({ page = 1, count = 20, filterValue, sortBy, sortOrder, dataCb, errCb }) => {
  const newPage = page - 1;
  const { serial_number, imsi, status } = filterValue ?? {};
  const params = {
    ...(serial_number ? { serial_number } : {}),
    ...(imsi ? { imsi } : {}),
    ...(status ? { status } : {}),
    ...(sortBy ? { sort_by: sortBy } : {}),
    ...(sortOrder ? { sort_order: sortOrder } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get(`devices/nbiot`, {
      _auth: true,
      params,
    });
    dataCb?.(response.data);
    return response;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

// admin: device firmware update policies
export const getDeviceUpdatePolicies = async ({ page = 1, count = 20, sortBy, sortOrder, serialNumber, dataCb, errCb }) => {
  const newPage = page - 1;
  const params = {
    ...(sortBy ? { sort_by: sortBy } : {}),
    ...(sortOrder ? { sort_order: sortOrder } : {}),
    ...(serialNumber ? { serial_number: serialNumber } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get(`admin/devices/update-policies`, {
      _auth: true,
      params,
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const updateDevicePolicyById = async ({ id, body, dataCb, errCb }) => {
  try {
    const response = await axiosRequest.patch(`admin/devices/${id}/update-policy`, body, {
      _auth: true,
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

export const updateAllDevicesPolicy = async ({ body, dataCb, errCb }) => {
  try {
    const response = await axiosRequest.patch(`admin/devices/update-policy`, body, {
      _auth: true,
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

export const updateDeviceTestFlag = async ({ id, isTestDevice, dataCb, errCb }) => {
  try {
    const response = await axiosRequest.patch(
      `admin/devices/${id}/test-device`,
      { is_test_device: isTestDevice },
      { _auth: true }
    );
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

export const getTestDevicesApi = async ({ dataCb, errCb } = {}) => {
  try {
    const response = await axiosRequest.get(`admin/devices/test-devices`, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getFirmwareApi = async ({ channel, dataCb, errCb } = {}) => {
  try {
    const response = await axiosRequest.get(`admin/devices/firmware`, {
      _auth: true,
      params: channel ? { channel } : {},
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

export const getFirmwareTestApi = async ({ dataCb, errCb } = {}) => {
  try {
    const response = await axiosRequest.get(`admin/devices/firmware-test`, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const startFirmwareTestApi = async ({ version, dataCb, errCb }) => {
  try {
    const response = await axiosRequest.post(`admin/devices/firmware-test/start`, { version }, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

export const verifyFirmwareTestApi = async ({ version, dataCb, errCb }) => {
  try {
    const response = await axiosRequest.post(`admin/devices/firmware-test/verify`, { version }, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

export const promoteFirmwareTestApi = async ({ dataCb, errCb } = {}) => {
  try {
    const response = await axiosRequest.post(`admin/devices/firmware-test/promote`, null, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

export const cancelFirmwareTestApi = async ({ dataCb, errCb } = {}) => {
  try {
    const response = await axiosRequest.post(`admin/devices/firmware-test/cancel`, null, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

export const excludeFirmwareTestDeviceApi = async ({ id, dataCb, errCb }) => {
  try {
    const response = await axiosRequest.delete(`admin/devices/${id}/firmware-test`, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

// admin: Метроны и прошивки nRF / MSP430. Только головная организация «Меридиан», остальным 403.
export const getMetronDevicesApi = async ({
  page = 1,
  count = 20,
  serialNumber,
  firmwareStatus,
  sortBy,
  sortOrder,
  dataCb,
  errCb,
} = {}) => {
  const params = {
    page: page - 1,
    count,
    ...(serialNumber ? { serial_number: serialNumber } : {}),
    ...(firmwareStatus ? { firmware_status: firmwareStatus } : {}),
    ...(sortBy ? { sort_by: sortBy } : {}),
    ...(sortOrder ? { sort_order: sortOrder } : {}),
  };

  try {
    const response = await axiosRequest.get('admin/metron/devices', {
      _auth: true,
      params,
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

// admin: журнал OTA-событий
export const getOtaEventsApi = async ({ page = 1, count = 50, searchParams, sortBy, sortOrder, dataCb, errCb } = {}) => {
  const newPage = page - 1;

  const {
    serial_number,
    device_model,
    device_type,
    event_type,
    firmware_file,
    from_version,
    to_version,
    has_new,
    allowed,
    status_code,
    only_errors,
    channel,
    from,
    to,
  } = searchParams ?? {};

  const statusCode = Number(status_code);

  const params = {
    ...(serial_number ? { serial_number } : {}),
    ...(device_model ? { device_model } : {}),
    ...(device_type ? { device_type } : {}),
    ...(event_type?.length ? { event_type: event_type.join(',') } : {}),
    ...(firmware_file ? { firmware_file } : {}),
    ...(from_version ? { from_version } : {}),
    ...(to_version ? { to_version } : {}),
    ...(has_new ? { has_new: has_new === 'true' } : {}),
    ...(allowed ? { allowed: allowed === 'true' } : {}),
    ...(status_code && !Number.isNaN(statusCode) ? { status_code: statusCode } : {}),
    ...(only_errors ? { only_errors: only_errors === 'true' } : {}),
    ...(channel ? { channel } : {}),
    ...(from ? { from: new Date(from).toISOString() } : {}),
    ...(to ? { to: new Date(to).toISOString() } : {}),
    ...(sortBy ? { sort_by: sortBy } : {}),
    ...(sortOrder ? { sort_order: sortOrder } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get(`admin/ota/events`, {
      _auth: true,
      params,
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getDefsApi = async (payload) => {
  const { dataCb, errCb } = payload ?? {};

  try {
    const response = await axiosRequest.get('defs');
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getOrganizationsDict = async (payload) => {
  const { dataCb, errCb } = payload ?? {};

  try {
    const response = await axiosRequest.get(`organizations/dict`, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const editOrganization = async (body, dataCb, errCb) => {
  try {
    await axiosRequest.patch(`organizations/edit`, body, {
      _auth: true,
    });
    dataCb?.();
  } catch (err) {
    parseErrors(err, errCb);
    throw err;
  }
};

// reports
export const getObjects = async (payload) => {
  const { dataCb, errCb } = payload ?? {};
  try {
    const response = await axiosRequest.get(`objects`, {
      _auth: true,
    });
    dataCb?.(response?.data || []);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const createReport = async (payload) => {
  const { dataCb, errCb, searchParams, typeFormat } = payload ?? {};
  const { from, to, object_id, format } = searchParams ?? {};
  const params = {
    ...(object_id ? { object_id } : {}),
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    ...(format ? { format } : {}),
  };
  const headers = { Accept: typeFormat };

  try {
    const response = await axiosRequest.get(`stats`, {
      _auth: true,
      params,
      responseType: 'blob',
      headers,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
    dataCb(response.data);
    return response.data;
  } catch (err) {
    const blob = err?.response?.data;

    if (blob && blob instanceof Blob) {
      const text = await blob.text();
      let json;
      try {
        json = JSON.parse(text);
      } catch {
        json = { error: text };
      }
      errCb?.(json);
    }
  }
};

// интеграции:

export const getIntegrations = async (payload) => {
  const { dataCb, errCb } = payload ?? {};
  try {
    const response = await axiosRequest.get(`manual-integrations`, {
      _auth: true,
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const completeIntegration = async (payload) => {
  const { body, dataCb, errCb } = payload ?? {};
  try {
    const response = await axiosRequest.patch(`manual-integrations/complete`, body, {
      _auth: true,
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const deferIntegration = async (payload) => {
  const { body, dataCb, errCb } = payload ?? {};
  try {
    const response = await axiosRequest.patch(`manual-integrations/defer`, body, {
      _auth: true,
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getCredentialsIntegration = async (payload) => {
  const { integration_id, dataCb, errCb } = payload ?? {};
  try {
    const response = await axiosRequest.get(`/manual-integrations/${integration_id}/credentials`, {
      _auth: true,
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getPermissions = async (payload) => {
  const { role, dataCb, errCb } = payload ?? {};

  try {
    const response = await axiosRequest.get(`settings/permissions?role_key=${role}`, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const setPermissions = async (payload) => {
  const { body, dataCb, errCb } = payload ?? {};

  try {
    const response = await axiosRequest.put(`settings/permissions`, body, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getRoles = async (payload) => {
  const { dataCb, errCb } = payload ?? {};

  try {
    const response = await axiosRequest.get(`auth/roles/dict`, { _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

// payments
export const getPayments = async ({ page = 1, count = 20, searchParams, sort, dataCb, errCb }) => {
  const newPage = page - 1;
  const { status, user_id } = searchParams ?? {};

  const params = {
    ...(status?.length ? { status } : {}),
    ...(user_id ? { user_id } : {}),
    ...(sort ? { sort } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get(`/payments/admin`, {
      _auth: true,
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};
